import {AppModule} from 'api/gen/AppModule';
import {AssociationType} from 'api/gen/AssociationType';
import {GridCode} from 'api/gen/GridCode';
import {Sex} from 'api/gen/Sex';

interface TableInfo {
    module: AppModule;
    code: GridCode;
}

/**
 * Resolves the table info for a mating workflow table.
 *
 * @param sex Sex-specific table mode.
 * @param associationType Association type used by the current workflow.
 * @returns The table info used by the shared table helpers.
 */
export const getTableInfo = (sex: Sex, associationType: AssociationType): TableInfo => ({
    module: associationType === 'FLECKVIEH' ? 'MATING_C' : 'MATING_H',
    code: sex === 'MALE' ? 'BULL' : 'COW',
});
